import {
  ContentCopy,
  EmailOutlined,
  PictureAsPdfOutlined,
} from "@mui/icons-material";
import { Button, Card, CardContent, Stack, Tooltip } from "@mui/material";
import React, { useCallback } from "react";
import { copyToClipboard } from "../utils/clipboard";

type Props = {
  message: string;
  canShare: boolean;
  onFeedback: (message: string, severity: "success" | "error" | "info") => void;
};

const ProposalActions: React.FC<Props> = ({
  message,
  canShare,
  onFeedback,
}) => {
  const copyWhatsapp = useCallback(async () => {
    try {
      await copyToClipboard(message);
      onFeedback("Mensagem copiada com sucesso.", "success");
    } catch {
      onFeedback("Não foi possível copiar a mensagem.", "error");
    }
  }, [message, onFeedback]);

  const generatePdf = useCallback(() => {
    // TODO: gerar a proposta em PDF com os dados estruturados.
    onFeedback("A geração de PDF será disponibilizada em breve.", "info");
  }, [onFeedback]);

  const sendEmail = useCallback(() => {
    // TODO: integrar o envio com a futura API de propostas/e-mail.
    onFeedback("O envio por e-mail será disponibilizado em breve.", "info");
  }, [onFeedback]);

  return (
    <Card>
      <CardContent>
        <Stack spacing={1.5}>
          <Tooltip
            title={canShare ? "Copiar mensagem" : "Selecione pelo menos um produto"}
          >
            <span>
              <Button
                fullWidth
                variant="contained"
                color="success"
                startIcon={<ContentCopy />}
                disabled={!canShare}
                onClick={copyWhatsapp}
              >
                Copiar WhatsApp
              </Button>
            </span>
          </Tooltip>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<PictureAsPdfOutlined />}
              onClick={generatePdf}
              color="info"
            >
              Gerar PDF
            </Button>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<EmailOutlined />}
              onClick={sendEmail}
              color="inherit"
            >
              Enviar e-mail
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ProposalActions;
